import { ChangeEvent, FC } from 'react';
import { Checkbox } from '@doda/io-react/common';
import classNames from 'classnames';
import { DrillDownText } from '../DrillDownText';
import styles from './index.module.scss';

/**
 * 配列要素の型定義
 * @param id
 * @param title
 * @param isChecked チェックボックスのチェック状態
 * @param url 遷移先URL
 */
interface ListType {
  id: string;
  title: string;
  jobCount: string;
  isChecked?: boolean;
  url?: string | null;
}

/**
 * 路線駅ドリルダウンの型定義
 * @param url 路線の遷移先URL
 * @param stations 駅のドリルダウン
 */
export interface RouteStationDrillDownType extends ListType {
  url?: string | undefined;
  stations: ListType[];
}

/**
 * Propsの型定義
 * @param param.route 路線駅ドリルダウン
 * @param param.onChange チェックボックスの更新処理
 */
interface Props {
  routes: RouteStationDrillDownType[];
  onChange: (event: ChangeEvent<HTMLInputElement>, selectedId: string) => void;
}

export const RouteStationDrillDown: FC<Props> = ({ routes, onChange }) => {
  return (
    <>
      {routes.map((route) => {
        return (
          <div key={route.id} className={styles.routeStationDrillDown__list}>
            <DrillDownText
              title={route.title}
              jobCount={route.jobCount}
              url={route.url}
              size="L"
            />
            {route.stations.map((station) => {
              return (
                <div
                  key={station.id}
                  className={classNames(
                    styles.routeStationDrillDown__station,
                    { '-route': station.isChecked !== undefined },
                    { '-station': station.isChecked === undefined }
                  )}
                >
                  {station.isChecked !== undefined ? (
                    <Checkbox
                      label={
                        <DrillDownText
                          title={station.title}
                          jobCount={station.jobCount}
                          url={station.url}
                          isBold={station.isChecked}
                          size="L"
                        />
                      }
                      value={station.id}
                      checked={station.isChecked}
                      onChange={(event) => {
                        if (station.url) {
                          onChange(event, station.id);
                        }
                      }}
                    />
                  ) : (
                    <DrillDownText
                      title={station.title}
                      jobCount={station.jobCount}
                      size="L"
                    />
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};
